import useTheme from 'shared/hooks/use-theme';

export const ExclusivePromoLabel = () => {
  const { channelName } = useTheme();

  return (
    <div>
      <span>
        Promo solo en <b>{channelName}</b> 🔥
      </span>
    </div>
  );
};
